export const baseFontSize = 16;
